<template>
    <!--nav-->
    <nav class="navbar navbar-default no-margin app-sidebar-nav">
        <div v-if="currentEnvironment" class="notification-block notification-block-top">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-primary alert-dismissible">
                <div class="scroll-left">
                    <p>This is Test Environment !</p>
                </div>
            </div>
        </div>
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header fixed-brand" style="background: #FFFFFF;">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" id="menu-toggle" v-on:click.prevent="menuTtoggleMobile(sidebarType)">
                <span class="" aria-hidden="true"></span>
            </button>
            <router-link v-bind:to="{ path:'/'}" class="navbar-brand"><img src="/static/images/vvg-home-logo.png" alt="HR Portal"></router-link>
        </div>
        <!-- navbar-header-->
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
            <ul class="nav navbar-nav">
                <li class="active">
                    <button class="navbar-toggle collapse in" data-toggle="collapse" id="menu-toggle-2" v-on:click.prevent="menuTtoggleDesktop(sidebarType)">
                        <img src="/static/images/menubar.png" alt="Menu" class="menubar">
                    </button>
                </li>
            </ul>
        </div>
        <!--notification-->
        <!--<div class="notification">
            <a href="#">
                <img src="/static/images/notification-bell.png" alt="Notification">
            </a>
        </div>-->
        <!--notification-->
        <!--userinfo-->
        <div class="user-info">
            <div class="user-info-container">
                <div class="dropdown">
                    <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                        <div class="dropdown-user">
                            <!--<div class="username-letter">AG</div>-->
                            <div class="image"><img :src="profile_image" alt="User" width="48" height="48"></div>
                            <div class="dropdown-user-right">
                                <div class="username">{{firstName}} {{lastName}}</div>
                                <br/>
                                <div class="usermailid">{{email}}</div>
                            </div>
                        </div>
                    </button>
                    <div class="dropdown-menu">
                        <router-link class="dropdown-item" v-bind:to="{ name: 'ChangeProfile',params:{id:0}}">My Profile</router-link>
                        <!--router-link class="dropdown-item" v-bind:to="{ name: 'TalentProfile',params:{id:0, from:''}}">Talent Profile</router-link-->
                        <a class="dropdown-item" href="#" v-on:click.prevent="logout()">Logout</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- bs-example-navbar-collapse-1 -->
    </nav>
</template>

<script>
    import Vue from "vue";
    import EventBus from '../../event-bus';
    import SessioMixin from '../../../mixins/sessionmixin';
    var self;
    export default {
        mixins: [SessioMixin],
        name: 'App',
        data() {
            return {
                userPermissions: [],
                roleId: 0,
                roleName: 0,
                system_year: '',
                isShowLoggedinfields: true,
                showEditProfile: true,
                isLoggedIn: false,
                firstName: "",
                lastName: "",
                email: "",
                profile_image: "",
                loggedinUserId: "",
                universalSearchText: "",
                sidebarType: ""
            }
        },
        components: {
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
            self.getPermissions();
        },
        mounted: function () {
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[1] == "directory") {
                self.showEditProfile = false;
            }
            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginID = userJson.id;
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"], localStorage.getItem("profile_image"));
            }
        },
        methods: {
            universalSearchAPI: function () {
                self.$router.push("/directory/extensionslist/" + self.universalSearchText);
            }
        },
    }
    EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.userPermissions = userPermissions;
            self.roleName = name;
            self.system_year = system_year;
            if ((self.roleId != 1 && self.roleId != 0) && self.userPermissions.indexOf('add_contact_extension') < -1 && userPermissions.indexOf('allow_user_management_module') < -1) {
                openDirectLink("/");
            }
        }
    });
    EventBus.$on('logged-in', function (isLogin, fname, lname, email, profile_image) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.firstName = fname;
            self.lastName = lname;
            self.email = email;
            self.profile_image = (profile_image != '') ? profile_image : '/static/images/default.jpg';
        }
    });

    EventBus.$on('searchText', function (data) {
        self.universalSearchText = data;
    });
    EventBus.$on('sidebarType', function (data) {
        if (typeof (self) != "undefined") {
            self.sidebarType = data;
        }
    });


</script>



// WEBPACK FOOTER //
// src/components/backend/partials/BackendHeader.vue